import type { ExternalTableSchema } from '@packages/table-builder';
import {
  releaseDetailsItemColumns,
  releaseItemFilters,
  releaseItemSearchRequestParams,
  withReleaseIdEndpoint,
} from '@apps/customer/pages/release/shared/releaseItemTableShared';

export { withReleaseIdEndpoint };

export const releaseDetailsItemsTable: ExternalTableSchema = {
  metadata: {
    title: 'Release Details',
    entity: 'ReleaseDetailsItems',
  },
  dataSource: {
    endpoint: '/api/award/api/app/release/{id}/release-detail',
    method: 'GET',
    rowIdField: 'id',
    requestParams: { ...releaseItemSearchRequestParams },
    filters: releaseItemFilters,
  },
  columns: releaseDetailsItemColumns,
  actions: {
    row: [
      { id: 'VIEW_DETAILS_RELEASE_DETAILS', label: 'View Details' },
      { id: 'REVERSE_RELEASE_DETAILS', label: 'Remove', variant: 'danger' },
      { id: 'DELETE_REVERSED_RELEASE_DETAILS', label: 'Delete', variant: 'danger' },
    ],
  },
  features: {
    search: { enabled: true },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
  },
};
